module.exports = {
      id: "close-usage",
      viewBox: "0 0 320 512",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#close",
      toString: function () {
        return this.url;
      }
    }